module.exports = __webpack_public_path__ + "static/media/undraw-time-management-30-iu.c87919e3.svg";